var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0390625,
    width: 52.1444,
    height: 52,
    rx: 10,
    fill: "#F985C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1113 20.4399V23.7699",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1316 16C22.4414 16 19.4531 18.98 19.4531 22.66V24.76C19.4531 25.44 19.1723 26.46 18.8213 27.04L17.5478 29.16C16.7656 30.47 17.3071 31.93 18.7511 32.41C23.5444 34 28.7288 34 33.5221 32.41C34.8758 31.96 35.4574 30.38 34.7254 29.16L33.4519 27.04C33.1009 26.46 32.8201 25.43 32.8201 24.76V22.66C32.8101 19 29.8018 16 26.1316 16Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.451 32.8199C29.451 34.6499 27.9468 36.1499 26.1117 36.1499C25.1992 36.1499 24.3568 35.7699 23.7552 35.1699C23.1535 34.5699 22.7725 33.7299 22.7725 32.8199",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotify);
export default __webpack_public_path__ + "static/media/notify.ac8e9ef970490e531c5b34e229ce172f.svg";
export { ForwardRef as ReactComponent };